module.exports = "/static-assets/_next/static/images/bg-mobile-27acc86c272653128bed88cc171f6b72.jpg";